<script setup>
import { computed } from 'vue'
import { getCurrencyIcon, getCurrencySymbol } from '@/utils/currency.js'

const props = defineProps({
  amount: {
    type: [Number, String],
    default: '',
  },
  currencyCode: {
    type: String,
    default: '',
  },
  prefix: {
    type: String,
    default: '',
  },
  displayAmount: {
    type: String,
    default: '',
  },
})

const amountText = computed(() => {
  if (props.displayAmount) {
    return props.displayAmount
  }

  if (props.amount === null || props.amount === undefined || props.amount === '') {
    return ''
  }

  const parsedAmount = parseFloat(props.amount)
  return Number.isFinite(parsedAmount) ? String(parsedAmount) : String(props.amount)
})

const currencyIcon = computed(() => getCurrencyIcon(props.currencyCode))
const currencySymbol = computed(() => getCurrencySymbol(props.currencyCode))
</script>

<template>
  <span class="currency-amount">
    <span v-if="amountText || prefix">{{ prefix }}{{ amountText }}</span>
    <img
      v-if="currencyIcon"
      class="currency-amount__icon"
      :src="currencyIcon"
      :alt="currencyCode.toUpperCase()"
    >
    <span v-else class="currency-amount__symbol">{{ currencySymbol }}</span>
  </span>
</template>

<style scoped lang="scss">
.currency-amount {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.currency-amount__icon {
  width: 1em;
  height: 1em;
  min-width: 1em;
  object-fit: contain;
  border-radius: 50%;
}
</style>
